import { useEffect, useState } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { CopyIcon } from "../../assets/icons/icons";
import {
  BackArrowIcon,
  CloseIcon,
  InfoIcon
} from "../../front-end-global-components/assets/assets";
import Button from "../../front-end-global-components/components/Button/Button";
import Header from "../../front-end-global-components/components/Header/Header";
import InputBox from "../../front-end-global-components/components/InputBox/InputBox";
import Modal from "../../front-end-global-components/components/Modal/Modal";
import OTPInputBox from "../../front-end-global-components/components/OTPInputBox/OTPInputBox";
import RoundedProfilePicture from "../../front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";
import {
  abhaNumberCreationRegister,
  checkHealthIdExists,
  clearHealthIdExistsStatus,
  registerNewAbhaNumber,
  resetABHANumberCreation,
  setAbdmTransactionId
} from "../../redux/abdm/actions";
import {
  // confirmAbdmLogin,
  setTransactionId
} from "../../redux/patients/actions";
import { setErrorStatus } from "../../redux/status/actions";
import AbdmCard from "../../Screens/ShowAbdmInfo/AbdmCard";
import { suggestABHAAddressFromABHANumberCreation } from "../../services/api";
import {
  // getMonthNumber,
  getValidGender
} from "../../utils/constants";
import { Regex } from "../../utils/regex";
import {
  isValidArray,
  isValidObject,
  validation
} from "../../utils/validators";
import ProcessSuccess from "../ProcessSuccess/ProcessSuccess";
import "./CreateAbhaNumber.css";

export default function CreateAbhaNumber(props) {
  const [formData, setFormData] = useState({
    aadhaarNumber: "",
    phoneNumber: "+91"
  });
  const [OTP, setOTP] = useState("");
  const [counter, setCounter] = useState(null);
  const [resendCount, setResendCount] = useState(0);
  const [showCreateABHAAddress, setShowCreateABHAAddress] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (props.transactionId) {
      setCounter(60);
    } else {
      setCounter(null);
    }
  }, [props.transactionId]);

  useEffect(() => {
    resetABHANumberCreation();
  }, []);

  useEffect(() => {
    if (counter === null) {
      return;
    }

    if (counter <= 0) {
      setCounter(null);
      return;
    }

    const timer = setTimeout(() => {
      setCounter((prev) => (prev > 0 ? prev - 1 : null));
    }, 1000);

    return () => clearTimeout(timer);
  }, [counter]);

  const resetStates = () => {
    setFormData({
      aadhaarNumber: "",
      phoneNumber: "+91"
    });
    setOTP("");
    setCounter(null);
    setTransactionId(null);
    setAbdmTransactionId(null);
    resetABHANumberCreation();
  };

  return (
    <>
      {location.pathname.includes("/viewCard") ? (
        <> </>
      ) : (
        <Modal
          show={true}
          canIgnore={false}
          position="position-fixed bottom-0 left-0 right-0"
          boxShadow="none"
          width="inherit-parent-width"
          background="background-transparent"
          height={
            (props.transactionId === null ||
              typeof props.transactionId === "string") &&
            props.abhaNumberDetails?.ABHAProfile?.mobileVerified === true
              ? "inherit-parent-height"
              : "height-fit-to-content"
          }
        >
          <div className="background-white box-shadow-default font-color-secondary inherit-parent-height">
            {!isValidObject(props.transactionId) &&
              !isValidObject(props.abhaNumberDetails) && (
                <div className="padding-larger">
                  <div className="display-flex flex-justify-content-space-between flex-align-items-center">
                    <div />
                    <div className="text-align-center font-family-gilroy-regular font-size-small">
                      CREATE ABHA NUMBER
                    </div>
                    <div
                      style={{
                        height: "12px",
                        width: "12px",
                        marginBottom: "2px"
                      }}
                      onClick={() => {
                        props.closeModal();
                        resetStates();
                      }}
                    >
                      <CloseIcon height="14" />
                    </div>
                  </div>
                  <div className="text-align-center font-family-gilroy-regular font-size-small padding-top-large">
                    OTP will be sent to your mobile number registered with
                    Aadhaar
                  </div>

                  <form
                    onChange={(event) => {
                      setFormData((prev) => ({
                        ...prev,
                        [event.target.name]: event.target.value
                      }));
                    }}
                    onSubmit={(event) => {
                      event.preventDefault();
                      if (formData.aadhaarNumber) {
                        registerNewAbhaNumber({
                          aadhaarNumber: formData.aadhaarNumber.trim(),
                          type: "sendAadhaarOtp"
                        });
                      }
                    }}
                  >
                    <InputBox
                      className="inherit-parent-width border-radius-default margin-vertical-large"
                      name="aadhaarNumber"
                      label="Aadhaar Number"
                      value={formData.aadhaarNumber}
                      type="password"
                      autoComplete="off"
                      required
                      data-cy="AADHAAR-NUMBER-FIELD"
                      validation={(value) => validation("aadhaarNumber", value)}
                    />

                    <InputBox
                      className="inherit-parent-width border-radius-default margin-vertical-large"
                      name="phoneNumber"
                      label="Phone Number"
                      value={formData.phoneNumber}
                      type="tel"
                      autoComplete="off"
                      required
                      data-cy="PHONE-NUMBER-FIELD"
                      notes="Enter aadhaar linked mobile number for easy access"
                      validation={(value) => validation("phoneNumber", value)}
                    />

                    <Button
                      text="Continue"
                      variant="primary"
                      type="submit"
                      disabled={
                        !(
                          validation("aadhaarNumber", formData.aadhaarNumber)
                            .status &&
                          formData.phoneNumber.length === 13 &&
                          formData.phoneNumber.length > 3 &&
                          validation("phoneNumber", formData.phoneNumber).status
                        )
                      }
                      boxShadow={false}
                      className="margin-top-default"
                      data-cy="CONTINUE-BUTTON"
                      loading={props.loading}
                    />
                  </form>
                </div>
              )}

            {isValidObject(props.transactionId) &&
              (!isValidObject(props.abhaNumberDetails) ||
                props.abhaNumberDetails?.ABHAProfile?.mobileVerified ===
                  false) && (
                <form
                  className="padding-larger"
                  onSubmit={(event) => {
                    event.preventDefault();

                    if (
                      props.abhaNumberDetails?.ABHAProfile?.mobileVerified ===
                      false
                    ) {
                      registerNewAbhaNumber({
                        otp: OTP,
                        mobileNumber: formData.phoneNumber,
                        type: "verifyMobileOtp"
                      });
                    } else {
                      registerNewAbhaNumber({
                        otp: OTP,
                        mobileNumber: formData.phoneNumber,
                        type: "verifyAadhaarOtp"
                      });
                    }
                  }}
                >
                  <div className="display-flex flex-justify-content-space-between flex-align-items-center">
                    <div
                      style={{
                        height: "12px",
                        width: "12px",
                        marginBottom: "2px"
                      }}
                      onClick={() => {
                        setOTP("");
                        setCounter(null);
                        setTransactionId(null);
                        setAbdmTransactionId(null);
                      }}
                    >
                      <BackArrowIcon height="14" />
                    </div>
                    <div className="text-align-center font-family-gilroy-regular font-size-small">
                      ENTER VERIFICATION OTP
                    </div>

                    <div />
                  </div>

                  <OTPInputBox
                    name="otp"
                    autoFocus
                    removeDefaultLabel={true}
                    value={OTP}
                    setValue={setOTP}
                    required
                    className="margin-bottom-large"
                  />

                  <div className="display-flex flex-justify-content-space-between font-size-medium margin-bottom-larger">
                    {resendCount >= 2 ? (
                      <div className="font-color-secondary font-size-small">
                        OTP Resend limit reached. Try after 30 minutes.
                      </div>
                    ) : (
                      <>
                        {counter &&
                        typeof counter === "number" &&
                        resendCount <= 2 ? (
                          <div>
                            {`00:${counter
                              .toString()
                              .padStart(2, "0")} seconds`}
                          </div>
                        ) : (
                          <div />
                        )}

                        <div
                          className={`${
                            typeof counter === "number" && resendCount < 2
                              ? "font-color-tertiary"
                              : "font-color-primary"
                          }`}
                          onClick={() => {
                            const isTimerActive =
                              typeof counter === "number" && counter > 0;

                            // 1. Block when timer is active (first 2 attempts)
                            if (isTimerActive && resendCount < 2) {
                              return;
                            }

                            // 2. Throw error after 2 attempts
                            if (resendCount >= 2) {
                              return setErrorStatus({
                                code: "custom",
                                message:
                                  "OTP Resend limit reached. Try after 30 minutes."
                              });
                            }

                            if (
                              props.abhaNumberDetails?.ABHAProfile
                                ?.mobileVerified === false
                            ) {
                              registerNewAbhaNumber({
                                mobileNumber: formData.phoneNumber,
                                type: "sendMobileOtp"
                              });
                            } else {
                              registerNewAbhaNumber({
                                aadhaarNumber: formData.aadhaarNumber,
                                type: "sendAadhaarOtp"
                              });
                            }

                            setCounter(60);
                            setResendCount((prev) => prev + 1);
                          }}
                        >
                          Resend OTP
                        </div>
                      </>
                    )}
                  </div>

                  <Button
                    text="Continue"
                    variant="primary"
                    type="submit"
                    boxShadow={false}
                    disabled={
                      !(
                        validation("aadhaarNumber", formData.aadhaarNumber)
                          .status &&
                        formData.phoneNumber.length === 13 &&
                        formData.phoneNumber.length > 3 &&
                        validation("phoneNumber", formData.phoneNumber)
                          .status &&
                        OTP.length === 6
                      )
                    }
                    className="margin-top-default"
                    data-cy="CONTINUE-BUTTON"
                    loading={props.loading}
                  />
                </form>
              )}

            {typeof props.transactionId === "string" &&
              props.abhaNumberDetails?.ABHAProfile?.mobileVerified ===
                false && (
                <div className="padding-larger">
                  <div className="display-flex flex-justify-content-space-between">
                    <div />
                    <div className="text-align-center font-family-gilroy-regular font-size-small">
                      VERIFICATION NEEDED
                    </div>
                    <div
                      style={{
                        height: "12px",
                        width: "12px",
                        marginBottom: "2px"
                      }}
                      onClick={() => {
                        props.closeModal();
                        resetStates();
                      }}
                    >
                      <CloseIcon height="14" />
                    </div>
                  </div>

                  <div className="text-align-center font-family-gilroy-regular font-size-small padding-top-large">
                    This mobile number is different from your Aadhaar registered
                    mobile number
                  </div>

                  <form
                    onSubmit={(event) => {
                      event.preventDefault();
                      registerNewAbhaNumber({
                        mobileNumber: formData.phoneNumber,
                        type: "sendMobileOtp"
                      });
                    }}
                  >
                    <InputBox
                      className="inherit-parent-width border-radius-default margin-vertical-large"
                      name="phoneNumber"
                      label="Phone Number"
                      value={formData.phoneNumber}
                      type="tel"
                      autoComplete="off"
                      required
                      data-cy="phone-number-field"
                      disabled={true}
                    />

                    <Button
                      text="Continue"
                      variant="primary"
                      type="submit"
                      disabled={formData.phoneNumber.length !== 13}
                      className="margin-top-default"
                      data-cy="CONTINUE-BUTTON"
                      boxShadow={false}
                      loading={props.loading}
                    />
                  </form>
                </div>
              )}

            {(props.transactionId === null ||
              typeof props.transactionId === "string") &&
              props.abhaNumberDetails?.ABHAProfile?.mobileVerified === true && (
                <>
                  <Header
                    title={
                      showCreateABHAAddress
                        ? "Create ABHA Address"
                        : "Create ABHA number"
                    }
                    backButtonOnClick={() => {
                      if (showCreateABHAAddress) {
                        setShowCreateABHAAddress(false);
                      } else {
                        navigate("/");
                      }
                    }}
                  />

                  {typeof props.abhaNumberDetails?.ABHAProfile?.newHealthId ===
                  "string" ? (
                    <div
                      style={{
                        height: "calc(100% - 64px)"
                      }}
                      className="padding-larger"
                    >
                      <ProcessSuccess
                        title="Congratulations! ABHA address is created successfully"
                        description={
                          <>
                            <div>
                              YOUR ABHA ADDRESS IS{" "}
                              <span className="font-family-gilroy-bold padding-top-large">
                                {
                                  props.abhaNumberDetails?.ABHAProfile
                                    ?.newHealthId
                                }
                              </span>
                            </div>
                            <div>
                              YOUR ABHA NUMBER IS{" "}
                              <span className="font-family-gilroy-bold padding-top-large">
                                {
                                  props.abhaNumberDetails?.ABHAProfile
                                    ?.ABHANumber
                                }
                              </span>
                            </div>
                            <div
                              className="font-size-small cursor-pointer font-color-primary text-underline padding-top-large"
                              onClick={() => {
                                navigate(
                                  `${window.location.pathname}/viewCard`
                                );
                                // navigate("/settings/abhaNumber/viewCard");
                              }}
                            >
                              View ABHA number Card
                            </div>
                          </>
                        }
                        buttonName="Continue"
                        confirmClick={() => {
                          navigate("/");
                          resetStates();
                        }}
                      />
                    </div>
                  ) : showCreateABHAAddress ? (
                    <div
                      style={{
                        height: "calc(100% - 64px)"
                      }}
                      className=""
                    >
                      <ABHADetailsForm
                        loading={props.loading}
                        auth={props.auth}
                        abhaNumberDetails={props.abhaNumberDetails}
                        isHealthIdExists={props.isHealthIdExists}
                      />
                    </div>
                  ) : (
                    <>
                      <div
                        style={{
                          height: "calc(100% - 170px)"
                        }}
                        className="padding-left-larger padding-right-larger overflow-scroll hide-scroll-bar"
                      >
                        <div
                          style={{
                            zIndex: "100"
                          }}
                          className="position-sticky top-0 padding-top-larger padding-bottom-larger background-color-white text-align-center font-family-gilroy-regular font-size-small"
                        >
                          ABHA NUMBER CREATED SUCCESSFULLY
                        </div>
                        <div>
                          <div className="display-flex flex-justify-content-center">
                            <RoundedProfilePicture
                              src={
                                `data:image/png;base64, ${props.abhaNumberDetails?.ABHAProfile.photo}` ||
                                null
                              }
                              size="medium"
                            />
                          </div>
                          <div className="text-align-center">
                            <div className="padding-top-small display-flex flex-justify-content-center">
                              <div className="font-size-small">
                                ABHA NUMBER :{" "}
                                {
                                  props.abhaNumberDetails?.ABHAProfile
                                    .ABHANumber
                                }
                              </div>
                              <div
                                className="cursor-pointer display-flex flex-align-items-center margin-left-large"
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    props.abhaNumberDetails?.ABHAProfile
                                      .ABHANumber
                                  );
                                }}
                              >
                                <CopyIcon />
                              </div>
                            </div>
                            <div
                              className="font-size-small cursor-pointer font-color-primary text-underline"
                              onClick={() => {
                                navigate(
                                  `${window.location.pathname}/viewCard`
                                );
                                // navigate("/settings/abhaNumber/viewCard");
                              }}
                            >
                              View ABHA number Card
                            </div>
                          </div>
                          <div className="">
                            {[
                              {
                                title: "FIRST NAME",
                                value:
                                  props.abhaNumberDetails?.ABHAProfile
                                    ?.firstName
                              },
                              {
                                title: "MIDDLE NAME",
                                value:
                                  props.abhaNumberDetails?.ABHAProfile
                                    ?.middleName
                              },
                              {
                                title: "LAST NAME",
                                value:
                                  props.abhaNumberDetails?.ABHAProfile?.lastName
                              },
                              {
                                title: "DATE OF BIRTH",
                                value: props.abhaNumberDetails?.ABHAProfile?.dob
                              },
                              {
                                title: "GENDER",
                                value: getValidGender(
                                  props.abhaNumberDetails?.ABHAProfile?.gender
                                ),
                                className: "text-capitalize"
                              },
                              {
                                title: "MOBILE NUMBER",
                                value:
                                  props.abhaNumberDetails?.ABHAProfile
                                    ?.userMobile ||
                                  props.abhaNumberDetails?.ABHAProfile?.mobile
                              },
                              {
                                title: "ADDRESS",
                                value:
                                  props.abhaNumberDetails?.ABHAProfile?.address
                              },
                              {
                                title: "STATE",
                                value:
                                  props.abhaNumberDetails?.ABHAProfile
                                    ?.stateName
                              },
                              {
                                title: "DISTRICT",
                                value:
                                  props.abhaNumberDetails?.ABHAProfile
                                    ?.districtName
                              },
                              {
                                title: "PIN CODE",
                                value:
                                  props.abhaNumberDetails?.ABHAProfile.pinCode
                              },
                              ...(props.abhaNumberDetails?.ABHAProfile
                                .phrAddress?.length > 0
                                ? [
                                    {
                                      title: "EXISTING ABHA ADDRESS",
                                      value:
                                        props.abhaNumberDetails?.ABHAProfile
                                          ?.phrAddress,
                                      list: true
                                    }
                                  ]
                                : [])
                            ].map((d, index) => (
                              <div className="" key={index}>
                                <div className="font-size-smaller padding-top-large padding-bottom-small">
                                  {d.title}
                                </div>
                                {d.list ? (
                                  <div
                                    style={{
                                      height: "200px"
                                    }}
                                    className="overflow-scroll hide-scroll-bar"
                                  >
                                    {d.value.map((data, i) => (
                                      <div
                                        key={i}
                                        // onClick={() => {
                                        //   confirmAbdmLogin(
                                        //     data?.healthId,
                                        //     props.auth?.data?.transactionId,
                                        //     ["MOBILE_OTP", "EMAIL_OTP"].includes(
                                        //       props.auth?.data?.authMode
                                        //     )
                                        //       ? props.auth?.data?.authMode
                                        //       : "ABHANUMBER",
                                        //     data.patientId,
                                        //     props.auth?.data?.abdmToken,
                                        //     navigate,
                                        //     true
                                        //   );
                                        // }}
                                        className="padding-bottom-default font-size-medium"
                                      >
                                        {data}
                                      </div>
                                    ))}
                                  </div>
                                ) : (
                                  <div
                                    className={`font-size-medium ${
                                      d.className || ""
                                    }`}
                                  >
                                    {d.value || "-"}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>

                        {props.auth.data.phoneNumber.replace("+91", "") !==
                          props.abhaNumberDetails?.ABHAProfile?.mobile && (
                          <div className="display-flex flex-align-items-center padding-bottom-large">
                            <div>
                              <InfoIcon color="red" />
                            </div>
                            <div
                              style={{
                                color: "red"
                              }}
                              className="padding-left-large font-size-small font-family-gilroy-regular"
                            >
                              This mobile number doesn’t match your Aadhaar
                              record. Click Continue to log in with the new
                              number.
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="padding-left-larger padding-right-larger">
                        <Button
                          text="Okay"
                          variant="primary"
                          type="button"
                          className="margin-top-large"
                          data-cy="CONTINUE-BUTTON"
                          loading={props.loading}
                          boxShadow={false}
                          onClick={() => {
                            props.closeModal();
                            resetStates();
                          }}
                        />
                        <div className="font-size-small padding-top-large padding-bottom-large text-align-center">
                          Still want to create a new ABHA address?
                          <span
                            className="font-color-primary "
                            onClick={() => {
                              setShowCreateABHAAddress(true);
                            }}
                          >
                            {" "}
                            Create
                          </span>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
          </div>
        </Modal>
      )}

      <Routes>
        <Route
          path="/viewCard"
          element={
            <div
              className=" inherit-parent-height inherit-parent-width position-fixed bottom-0 left-0 right-0"
              style={{ zIndex: 100, background: "white" }}
            >
              <AbdmCard type="ABHA Number" />{" "}
            </div>
          }
        />
      </Routes>
    </>
  );
}

function ABHADetailsForm(props) {
  const [suggestedIds, setSuggestedIds] = useState(null);
  const [suggestionsLoading, setSuggestionsLoading] = useState(false);
  const [formData, setFormData] = useState({
    healthId: ""
  });

  const fetchSuggestions = async () => {
    const { auth, abhaNumberDetails } = props;
    const accessToken = auth.data.accessToken;

    setSuggestionsLoading(true);
    try {
      const response = await suggestABHAAddressFromABHANumberCreation(
        accessToken,
        {
          transactionId: abhaNumberDetails?.txnId
        }
      );

      if (response.success) {
        setSuggestedIds(response.data.abhaAddressList);
      }
    } catch {
      setSuggestedIds(null);
    } finally {
      setSuggestionsLoading(false);
    }
  };

  useEffect(() => {
    fetchSuggestions();
    // eslint-disable-next-line
  }, [props.abhaNumberDetails]);

  const healthIdExistCheckHandler = () => {
    const rawHealthId = formData?.healthId;
    const healthId = rawHealthId?.trim() || "";

    const isInvalid =
      healthId.length < 4 ||
      healthId.length > 18 ||
      !Regex.healthId.test(healthId) ||
      props.loading;

    if (isInvalid) {
      return;
    }

    setFormData((prev) => {
      return {
        ...prev,
        prevHealthId: healthId
      };
    });

    checkHealthIdExists(healthId);
  };

  return (
    <form
      className="padding-horizontal-larger inherit-parent-height display-flex flex-justify-content-space-between flex-direction-column"
      autoComplete="off"
      onChange={(event) => {
        if (event.target.name === "healthId") {
          clearHealthIdExistsStatus();
        }
        if (props.loading === true && event.target.name === "healthId") {
          return;
        }
        setFormData((prev) => ({
          ...prev,
          [event.target.name]: event.target.value
        }));
      }}
      onSubmit={(event) => {
        event.preventDefault();
        abhaNumberCreationRegister({
          healthId: formData.healthId,
          transactionId: props.abhaNumberDetails?.txnId,
          token: props.abhaNumberDetails?.token
        });
      }}
    >
      <div>
        <InputBox
          inputSuffixPlaceHolder={"@sbx"}
          labelClassName="letter-spacing-4-percentage"
          className="inherit-parent-width border-radius-default padding-top-large"
          label="ABHA ADDRESS *"
          type="text"
          name="healthId"
          autoComplete="off"
          autoFocus={false}
          value={formData.healthId}
          loading={props.loading}
          inputNotesClassName="font-color-primary font-size-smaller padding-top-small"
          notes={
            formData.healthId &&
            props.isHealthIdExists === false && (
              <div style={{ color: "green", marginBottom: 6 }}>
                This ABHA Address is available.
              </div>
            )
          }
          validation={() => {
            if (formData.healthId.length < 8 || formData.healthId.length > 18) {
              return {
                status: false,
                message:
                  "ABHA Address must be between 8 and 18 characters long."
              };
            } else if (Regex.healthId?.test(formData.healthId) === false) {
              return {
                status: false,
                message:
                  "ABHA Address must start with a letter and may contain only one dot or underscore in between."
              };
            } else if (props.isHealthIdExists === true) {
              return {
                status: false,
                message:
                  "This ABHA Address is already taken. Please choose another."
              };
            } else {
              return {
                status: true
              };
            }
          }}
          autocomplete="off"
          onOutOfFocus={healthIdExistCheckHandler}
          onBlur={healthIdExistCheckHandler}
        />

        {suggestionsLoading && (
          <div
            style={{
              color: "black",
              marginTop: "4px",
              fontSize: "12px"
            }}
          >
            Loading suggestions...
          </div>
        )}

        {!suggestionsLoading && isValidArray(suggestedIds) && (
          <div>
            <div
              style={{
                color: "black",
                marginBottom: 4,
                marginTop: "4px",
                fontSize: "12px"
              }}
            >
              Suggestions:
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px"
              }}
            >
              {suggestedIds.map((id) => (
                <div
                  key={id}
                  style={{
                    color: "blue",
                    cursor: "pointer",
                    textDecoration: "underline",
                    whiteSpace: "nowrap",
                    width: "fit-content",
                    fontSize: "12px"
                  }}
                  onClick={() =>
                    setFormData((prev) => ({
                      ...prev,
                      healthId: id
                    }))
                  }
                >
                  {id}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div>
        <Button
          text="Submit"
          data-cy="CONTINUE-BUTTON"
          boxShadow={false}
          className="margin-top-large margin-bottom-larger"
          required
          type="submit"
          disabled={
            props.error || suggestionsLoading || props.loading ? true : false
          }
          loading={props.loading}
        />
      </div>
    </form>
  );
}
